module.exports = __webpack_public_path__ + "img/sld_scb_3_t1_dark.44ec1f40.svg";